import {MenuOutlined} from '@ant-design/icons';
import {Button, Divider, Drawer, Menu} from 'antd';
import PropTypes from 'prop-types';
import  React, {useState} from 'react';
import {Link, NavLink, useLocation, useNavigate} from 'react-router-dom';

import logo from '../../../assets/logo.png';

// import logo from '../../../assets/Images/Logo.png';
const DrawerMenu = ({items}) => {
  const [open, setOpen] = useState(false);

  const [placement] = useState('left');

  const location = useLocation();

  const navigate = useNavigate();

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <div className={'p-2'}>
      <Button
        icon={<MenuOutlined />}
        onClick={showDrawer}
        type={'text'}
        className={'text-xl'}
      />
      <Drawer
        title={null}
        placement={placement}
        width={200}
        onClose={onClose}
        open={open}
        bodyStyle={{padding: 0}}
        headerStyle={{display: 'none'}}
      >
        <div className={'bg-white h-full text-white flex flex-col justify-between'}>
          <div>
            <div className={'h-16 flex items-center justify-center border-b border-gray-700'}>
              <Link to={'/'}>
                <div className={'w-full h-12 flex items-center justify-center'}>
                  <img src={logo} alt={'logo'} className={'w-full h-full object-contain'}  />
                </div>
              </Link>
            </div>
            <Divider className={'my-2'} />
            <Menu mode={'inline'} className={'custom-menu'} selectedKeys={[location.pathname]}>
              {items.map((item, index) => (
                <React.Fragment key={index}>
                  <Menu.Item
                    key={item.path}
                    icon={item.icon}
                    onClick={() => {
                      onClose();
                      navigate(item.path);
                    }}
                  >
                    {item.label}
                  </Menu.Item>
                  {index !== items.length - 1 && (
                    <Divider className={'my-2 border-gray-300'} />
                  )}
                </React.Fragment>
              ))}
            </Menu>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

DrawerMenu.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.node,
      path: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default DrawerMenu;
